import { apiUrl } from "utils/urls";

import axios from "axios";

export const listReviewPage = async (params) => {
    const { data } = await axios.get(apiUrl("review") + `/${params.reference_file_uuid}?page=${params.page}`);
    return data;
};

export const getReviewPdfFile = async (fileUrl) => {
    const apiOrigin = new URL(apiUrl("review")).origin;
    const resolvedFileUrl = new URL(fileUrl, apiOrigin).href;
    const { data } = await axios.get(resolvedFileUrl, { responseType: "arraybuffer" });
    return data;
};

export const getReviewPageLayout = async ({ reference_file_uuid, page }) => {
    const { data } = await axios.get(apiUrl("review") + `/${reference_file_uuid}/layout`, {
        params: { page },
    });
    return data;
};
